import FdMarketplaceOfferCheckoutBannerPage from "@faire/prototype-playground/workspace/wa/fd-marketplace-offer-checkout-banner";
import SavingsInsights2027Page from "@faire/prototype-playground/workspace/wa/savings-insights-2027";
import ShopifyPosOnboardingHoverableDetailsPage from "@faire/prototype-playground/workspace/wa/shopify-pos-onboarding-hoverable-details";
import { Route, Switch } from "react-router-dom";

export function WahabAhmadRoutes() {
  return (
    <Switch>
      <Route
        path="/wa/fd-marketplace-offer-checkout-banner"
        component={FdMarketplaceOfferCheckoutBannerPage}
      />
      <Route
        path="/wa/savings-insights-2027"
        component={SavingsInsights2027Page}
      />
      <Route
        path="/wa/shopify-pos-onboarding-hoverable-details"
        component={ShopifyPosOnboardingHoverableDetailsPage}
      />
    </Switch>
  );
}

export const slug = "wa";
